import { connect } from 'react-redux';
import View from './PlanToGetMortgageView';
import {
  currentClientId,
  iterator,
  isPopulatedSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import { updateSupportData, updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';
import { hasMortgageSelector } from '../Mortgage/MortgageSelector';
import nextIteratorsSelector, {
  nullableHasPlanToGetMortgageSelector,
  alreadyHadMortgageSelector,
} from './PlanToGetMortgageSelector';

const computeGraphHomePurchaseNodeBasedOnPlanToGetMortgage = (hasPlanToGetMortgage, data) => {
  if (hasPlanToGetMortgage === false) {
    return {
      [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
        ...data[HOME_PURCHASE_GOAL_GRAPH_NODE],
        InterestRate: null,
        MortgageType: null,
        DownPayment: data[HOME_PURCHASE_GOAL_GRAPH_NODE].MarketValue,
      },
    };
  }
  return data;
};

const mapStateToProps = (state, ownProps) => ({
  iterator: iterator(state, ownProps),
  clientId: currentClientId(state, ownProps),
  hasPlanToGetMortgage: nullableHasPlanToGetMortgageSelector(state, ownProps),
  alreadyHadMortgage: alreadyHadMortgageSelector(state, ownProps),
  hasMortgage: hasMortgageSelector(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
  nextIterators: nextIteratorsSelector(state, ownProps),
  workflowId: ownProps.workflowId,
});

const mapDispatchToProps = dispatch => ({
  prepopulateHasMortgage: (workflowId) => {
    dispatch(updateSupportData(
      {
        [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
          HasPlanToGetMortgage: true,
          AlreadyHadMortgage: true,
        },
      },
      workflowId,
    ));
  },
  onHasPlanToGetMortgageChanged: workflowId => ({ target: { checked } }) => {
    dispatch(updateSupportData(
      {
        [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
          HasPlanToGetMortgage: checked,
        },
      },
      workflowId,
    ));
  },
  onPostProcess: hasPlanToGetMortgage => data =>
    computeGraphHomePurchaseNodeBasedOnPlanToGetMortgage(hasPlanToGetMortgage, data),
  onPostSave: (hasPlanToGetMortgage, workflowId) => data =>
    dispatch(updateData(
      computeGraphHomePurchaseNodeBasedOnPlanToGetMortgage(hasPlanToGetMortgage, data),
      workflowId,
    )),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
